module.exports = __webpack_public_path__ + "img/TechCavAttack2_ua.0493ea0e.webp";